import { OrgGuard } from "@/components/GuardComponents/OrgGuard";
import { Loading } from "@/components/Loading/Loading";
import { OrgGuardRequiredStatus } from "@/typed/OrgGuardRequiredStatus";
import { useAuth0 } from "@auth0/auth0-react";
import { FC, ReactNode } from "react";

interface OnboardingGuardProps {
  children: ReactNode;
}

/**
 * A guard component that restricts access to its children if the user
 * does not have a valid session token or is already part of an organisation.
 *
 * @param {ReactNode} children The guarded children or a redirect/loading state.
 */
export const OnboardingGuard: FC<OnboardingGuardProps> = ({ children }) => {
  const { loginWithRedirect, isLoading } = useAuth0();

  const token = new URL(window.location.href).searchParams.get("session_token");
  const state = new URL(window.location.href).searchParams.get("state");

  if (!token || !state) {
    // If no session token or state, redirect to login
    loginWithRedirect();
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <OrgGuard requiredOrgStatus={OrgGuardRequiredStatus.NO_ORG} redirectRoute="/cases">
      {children}
    </OrgGuard>
  );
};
